import React from 'react';
import EntryForm from './EntryForm'; // Import the EntryForm component

const CustomerDetails = () => {
  return (
    <EntryForm /> // Render the EntryForm component
  );
};

export default CustomerDetails;